export interface IColumns {
  id: 'amount' | 'asset'
  label: string
  // eslint-disable-next-line
  format?: (value: any) => number
}

export interface IDataItem {
  amount?: string
  asset?: string
}

export interface IData {
  request: (value: string, companyId?: string) => string
  columns: IColumns[]
}

const genCompanyParam = (companyId?: string) => (companyId ? `?companyId=${companyId}` : '')

export const tradingBalances: IData = {
  request: (value: string, companyId?: string) => `user/${value}/balance/trading${genCompanyParam(companyId)}`,
  columns: [
    {
      id: 'amount',
      label: 'AMOUNT',
    },
    {
      id: 'asset',
      label: 'CURRENCY',
    },
  ],
}

export const pendingBalances: IData = {
  request: (value: string, companyId?: string) => `user/${value}/balance/trading/pending${genCompanyParam(companyId)}`,
  columns: [
    {
      id: 'amount',
      label: 'AMOUNT',
    },
    {
      id: 'asset',
      label: 'CURRENCY',
    },
  ],
}

export const stakedBalances: IData = {
  request: (value: string, companyId?: string) => `user/${value}/balance/staking${genCompanyParam(companyId)}`,
  columns: [
    {
      id: 'amount',
      label: 'AMOUNT',
    },
    {
      id: 'asset',
      label: 'ASSET',
    },
  ],
}

export const unclaimedBalances: IData = {
  request: (value: string, companyId?: string) =>
    `user/${value}/balance/staking/unclaimed${genCompanyParam(companyId)}`,
  columns: [
    {
      id: 'amount',
      label: 'AMOUNT',
    },
    {
      id: 'asset',
      label: 'ASSET',
    },
  ],
}
